import React, { FC, useMemo } from 'react';

import useComposeType from '../../../../hooks/router/search/useComposeType';

import ComposeFooterNavItem from './ComposeFooterNavItem';
import { getComposeNavItems } from './helpers';
import * as Styled from './styled';
import { Props } from './types';

/**
 * Footer for compose
 *
 * @param props              Props passed to the component
 * @param props.formId       id attribute for the form related to submit button
 * @param props.isPending    Whether the mutation is in progress
 * @param props.labelConfirm The text to show for confirm label
 * @param props.nodeType     The type of compose node
 * @param props.updates      Updates state for the navigation in footer
 * @returns                  The component itself
 */
const ComposeFooter: FC<Props> = ({
  formId,
  isPending,
  labelConfirm,
  nodeType,
  updates,
}) => {
  const composeType = useComposeType();

  if (composeType === null) {
    return null;
  }

  const navItems = useMemo(
    () => getComposeNavItems(nodeType, composeType, updates),
    [nodeType, composeType, updates],
  );

  return (
    <Styled.Footer>
      <Styled.Navigation>
        <Styled.NavigationList>
          {navItems.map(itemProps => {
            const { CustomComponent, mode } = itemProps;
            const component =
              CustomComponent !== undefined ? (
                <CustomComponent nodeType={nodeType} />
              ) : (
                <ComposeFooterNavItem {...itemProps} />
              );

            return <li key={mode}>{component}</li>;
          })}
          <li>
            <Styled.SubmitButton
              color="tertiary"
              form={formId}
              loading={isPending}
              type="submit"
              variant="contained"
            >
              {labelConfirm}
            </Styled.SubmitButton>
          </li>
        </Styled.NavigationList>
      </Styled.Navigation>
    </Styled.Footer>
  );
};

export default ComposeFooter;
